import { type RefObject, useEffect } from 'react';

interface IUseIntersectionObserverProps {
  element: RefObject<HTMLElement | null>;
  callback: (isIntersecting: boolean) => void;
  threshold?: number[] | number;
  root?: null | Element;
  rootMargin?: string;
}

function useIntersectionObserver({ element, callback, threshold, root, rootMargin }: IUseIntersectionObserverProps) {
  useEffect(() => {
    const observedElement = element.current;
    if (!observedElement) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        callback(!!entry?.isIntersecting);
      },
      {
        threshold,
        root,
        rootMargin,
      }
    );
    observer.observe(observedElement);

    return () => observer.disconnect();
  }, [callback, element, root, rootMargin, threshold]);
}

export default useIntersectionObserver;
